export default __webpack_public_path__ + "static/cafe_36042-3df4dd472a5748c967979768b7a3d25e.png";